import * as Yup from 'yup';

export default Yup.object().shape({
  newCallerId: Yup.string().required(),
  isPermanent: Yup.string().required(),
});
